import { call, type Result } from "./dashboard/api";

// POST /v1/web/goals: the calculator's "Save my goal". One goal per member,
// or per browser for a visitor, so the admin Goals tab counts people, not
// clicks.

export type GoalRole = "producer" | "fan";
export type GoalFocus = "money" | "buzz";

export type GoalInput = {
  role: GoalRole;
  goal_cents: number;
  genre: string;
  focus?: GoalFocus;
};

export type SavedGoal = { member: boolean };

const VISITOR_KEY = "bf:visitor";

// visitorId names this browser across saves so a visitor's later saves
// replace their earlier one. Storage can be blocked; then every save is new.
export function visitorId(): string {
  const fresh = () => globalThis.crypto?.randomUUID?.() ?? `${Date.now()}-${Math.random().toString(36).slice(2)}`;
  try {
    const known = window.localStorage.getItem(VISITOR_KEY);
    if (known) return known;
    const id = fresh();
    window.localStorage.setItem(VISITOR_KEY, id);
    return id;
  } catch {
    return fresh();
  }
}

const savedBody = (raw: unknown): SavedGoal | null =>
  raw && typeof raw === "object" ? { member: (raw as { member?: unknown }).member === true } : null;

export function saveGoal(input: GoalInput): Promise<Result<SavedGoal>> {
  return call("POST", "/v1/web/goals", { ...input, visitor_id: visitorId() }, savedBody, "Couldn't save your goal. Try again.");
}
